import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "grid"
}
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "grid" }
const _hoisted_4 = { class: "col-12 p-inputgroup" }
const _hoisted_5 = { class: "p-inputgroup-addon" }
const _hoisted_6 = { class: "col-12 p-inputgroup" }
const _hoisted_7 = { class: "p-inputgroup-addon" }
const _hoisted_8 = { class: "col-12 p-inputgroup" }
const _hoisted_9 = { class: "p-inputgroup-addon" }
const _hoisted_10 = { class: "col-12 p-inputgroup" }
const _hoisted_11 = { class: "p-inputgroup-addon" }
const _hoisted_12 = { class: "col-12 p-inputgroup" }
const _hoisted_13 = { class: "p-inputgroup-addon" }
const _hoisted_14 = { class: "col-12 p-inputgroup" }
const _hoisted_15 = { class: "p-inputgroup-addon" }
const _hoisted_16 = { class: "col-6 p-inputgroup" }
const _hoisted_17 = { class: "ml-3" }
const _hoisted_18 = { class: "grid p-fluid" }
const _hoisted_19 = { class: "col-10 md:col-12" }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = {
  key: 2,
  class: "grid"
}
const _hoisted_22 = { class: "col-6 p-inputgroup" }
const _hoisted_23 = { class: "p-float-label" }
const _hoisted_24 = { class: "col-6" }
const _hoisted_25 = { class: "col-12" }
const _hoisted_26 = { class: "flex -my-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Prompt = _resolveComponent("Prompt")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("h5", null, _toDisplayString($setup.t("content.dataManagement.content.infrastructure.form.basicData")), 1),
      ($setup.state.infrastructureDto)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("span", _hoisted_5, _toDisplayString($setup.t("content.dataManagement.content.infrastructure.form.name")), 1),
                  _createVNode(_component_InputText, {
                    modelValue: $setup.state.infrastructureDto.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.state.infrastructureDto.name) = $event)),
                    placeholder: 
                $setup.t('content.dataManagement.content.infrastructure.form.name')
              
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString($setup.t("content.dataManagement.content.infrastructure.form.nameEng")), 1),
                  _createVNode(_component_InputText, {
                    modelValue: $setup.state.infrastructureDto.nameEnglish,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.state.infrastructureDto.nameEnglish) = $event)),
                    placeholder: 
                $setup.t('content.dataManagement.content.infrastructure.form.nameEng')
              
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString($setup.t(
                "content.dataManagement.content.infrastructure.form.description"
              )), 1),
                  _createVNode(_component_InputText, {
                    modelValue: $setup.state.infrastructureDto.description,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.state.infrastructureDto.description) = $event)),
                    placeholder: 
                $setup.t(
                  'content.dataManagement.content.infrastructure.form.description'
                )
              
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("span", _hoisted_11, _toDisplayString($setup.t("content.dataManagement.content.equipment.form.organization")), 1),
                  _createVNode(_component_Dropdown, {
                    modelValue: $setup.state.infrastructureDto.researchOrganizationId,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.state.infrastructureDto.researchOrganizationId) = $event)),
                    options: $setup.researchOrganizationState.group,
                    "option-label": "name",
                    "option-value": "id",
                    placeholder: $setup.t('content.globalSelectTitle')
                  }, {
                    option: _withCtx((slotProps) => [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", null, _toDisplayString(slotProps.option.number) + " " + _toDisplayString(slotProps.option.name), 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "options", "placeholder"])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("span", _hoisted_13, _toDisplayString($setup.t(
                "content.dataManagement.content.infrastructure.form.contactPerson"
              )), 1),
                  _createVNode(_component_MultiSelect, {
                    modelValue: $setup.state.infrastructureDto.contactUserIds,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.state.infrastructureDto.contactUserIds) = $event)),
                    options: $setup.state.filteredUsers,
                    "option-label": "firstname",
                    "option-value": "id",
                    placeholder: $setup.t('content.globalSelectTitle')
                  }, {
                    option: _withCtx((slotProps) => [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", null, _toDisplayString(slotProps.option.firstname) + " " + _toDisplayString(slotProps.option.lastname), 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "options", "placeholder"])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("span", _hoisted_15, _toDisplayString($setup.t(
                "content.dataManagement.content.infrastructure.form.researchGroup"
              )), 1),
                  _createVNode(_component_MultiSelect, {
                    modelValue: $setup.state.infrastructureDto.researchGroupIds,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.state.infrastructureDto.researchGroupIds) = $event)),
                    options: $setup.getResearchCategories.researchGroup,
                    "option-label": "number",
                    "option-value": "id",
                    placeholder: $setup.t('content.globalSelectTitle')
                  }, {
                    option: _withCtx((slotProps) => [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", null, _toDisplayString(slotProps.option.number) + " " + _toDisplayString(slotProps.option.name), 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "options", "placeholder"])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_InputSwitch, {
                    modelValue: $setup.state.infrastructureDto.isPublicVisible,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.state.infrastructureDto.isPublicVisible) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("span", _hoisted_17, _toDisplayString($setup.t(
                "content.dataManagement.content.infrastructure.form.isPublicVisible"
              )), 1)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_Button, {
            label: $setup.t('content.globalSaveButton'),
            class: "minWidth",
            onClick: $setup.onResearchInfrastructureCreateClick
          }, null, 8, ["label", "onClick"])
        ])
      ]),
      ($setup.isEditModeEnabled)
        ? (_openBlock(), _createElementBlock("h5", _hoisted_20, _toDisplayString($setup.t("content.dataManagement.content.infrastructure.form.equipment")), 1))
        : _createCommentVNode("", true),
      ($setup.isEditModeEnabled)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_Dropdown, {
                  modelValue: $setup.state.researchEquipmentId,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.state.researchEquipmentId) = $event)),
                  options: $setup.state.researchEquipmentItems,
                  "option-label": "name",
                  "option-value": "id",
                  filter: true,
                  class: "w-full",
                  "show-clear": true,
                  onFilter: _cache[8] || (_cache[8] = ($event: any) => ($setup.onResearchEquipmentFilterChange($event))),
                  onChange: _cache[9] || (_cache[9] = ($event: any) => ($setup.onResearchEquipmentChange($event)))
                }, null, 8, ["modelValue", "options"])
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createVNode(_component_Button, {
                label: $setup.t('content.globalAddNewButton'),
                class: "minWidth p-button",
                onClick: $setup.onEquipmentAddClick
              }, null, 8, ["label", "onClick"])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createVNode(_component_DataTable, {
                class: "p-datatable-sm",
                "column-resize-mode": "fit",
                "resizable-columns": true,
                "responsive-layout": "scroll",
                lazy: true,
                "total-records": $setup.state.lazyParams.total,
                "selection-mode": "single",
                value: $setup.state.researchEquipments,
                "filter-display": "menu",
                paginator: true,
                rows: $setup.state.lazyParams.rows,
                "rows-per-page-options": [5, 10, 40],
                "paginator-template": "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
                "current-page-report-template": `{currentPage} ${$setup.t(
            'content.globalPagingInformation.ofTitle'
          )} {totalPages} ${$setup.t('content.globalPagingInformation.pagesTitle')}`,
                "data-key": "id",
                loading: $setup.state.dataLoading,
                onPage: _cache[10] || (_cache[10] = ($event: any) => ($setup.onPaginatorResearchEquipmentClick($event)))
              }, {
                paginatorend: _withCtx(() => []),
                empty: _withCtx(() => [
                  _createTextVNode(_toDisplayString($setup.t("content.noData")), 1)
                ]),
                loading: _withCtx(() => [
                  _createTextVNode(_toDisplayString($setup.t("content.globalLoadingText")), 1)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_Column, {
                    field: "number",
                    header: 
              $setup.t('content.dataManagement.content.equipment.table.header.number')
            
                  }, {
                    body: _withCtx((slotProps) => [
                      _createTextVNode(_toDisplayString(slotProps.data.number), 1)
                    ]),
                    _: 1
                  }, 8, ["header"]),
                  _createVNode(_component_Column, {
                    field: "name",
                    header: 
              $setup.t('content.dataManagement.content.equipment.table.header.name')
            
                  }, {
                    body: _withCtx((slotProps) => [
                      _createTextVNode(_toDisplayString(slotProps.data.name), 1)
                    ]),
                    _: 1
                  }, 8, ["header"]),
                  _createVNode(_component_Column, {
                    field: "nameEnglish",
                    header: 
              $setup.t(
                'content.dataManagement.content.equipment.table.header.nameEnglish'
              )
            
                  }, {
                    body: _withCtx((slotProps) => [
                      _createTextVNode(_toDisplayString(slotProps.data.nameEnglish), 1)
                    ]),
                    _: 1
                  }, 8, ["header"]),
                  _createVNode(_component_Column, {
                    field: "purchaseEquipmentDateYear",
                    header: 
              $setup.t(
                'content.dataManagement.content.equipment.table.header.purchaseEquipmentDateYear'
              )
            
                  }, {
                    body: _withCtx((slotProps) => [
                      _createTextVNode(_toDisplayString(slotProps.data.purchaseEquipmentDateYear), 1)
                    ]),
                    _: 1
                  }, 8, ["header"]),
                  _createVNode(_component_Column, {
                    field: "location",
                    header: 
              $setup.t(
                'content.dataManagement.content.equipment.table.header.location'
              )
            
                  }, {
                    body: _withCtx((slotProps) => [
                      _createElementVNode("p", null, _toDisplayString(slotProps.data.location.street) + ", " + _toDisplayString(slotProps.data.location.postalCode) + " " + _toDisplayString(slotProps.data.location.cityName), 1)
                    ]),
                    _: 1
                  }, 8, ["header"]),
                  _createVNode(_component_Column, {
                    field: "link",
                    header: 
              $setup.t(
                'content.dataManagement.content.equipment.table.header.detailView'
              )
            
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_router_link, {
                        class: "router-link link",
                        to: {
                  name: 'research-equipment-detail',
                  params: { id: slotProps.data.id },
                }
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($setup.t("header.link")), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]),
                    _: 1
                  }, 8, ["header"]),
                  _createVNode(_component_Column, {
                    field: "id",
                    header: "",
                    "header-style": "text-align:center; width: 20px;"
                  }, {
                    body: _withCtx(({ data }) => [
                      _createElementVNode("div", _hoisted_26, [
                        _createVNode(_component_Button, {
                          icon: "pi pi-times",
                          class: "p-button-outlined p-button-danger ml-2",
                          onClick: ($event: any) => ($setup.onRemoveEquipmentClickOpenDialog(data.id))
                        }, null, 8, ["onClick"])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["total-records", "value", "rows", "current-page-report-template", "loading"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_Prompt, {
      visible: $setup.state.promptRemoveEquiopment,
      type: "alert",
      title: $setup.t('content.globalDeleteButton'),
      onClose: _cache[13] || (_cache[13] = ($event: any) => ($setup.state.promptRemoveEquiopment = false))
    }, {
      content: _withCtx(() => [
        _createElementVNode("h3", null, _toDisplayString($setup.t("content.globalAreYouSure")), 1)
      ]),
      actions: _withCtx(() => [
        _createVNode(_component_Button, {
          class: "p-button-outlined",
          label: $setup.t('content.globalCancelButton'),
          onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.state.promptRemoveEquiopment = false))
        }, null, 8, ["label"]),
        _createVNode(_component_Button, {
          label: $setup.t('content.globalDeleteButton'),
          onClick: _cache[12] || (_cache[12] = ($event: any) => ($setup.onRemoveEquipmentClick()))
        }, null, 8, ["label"])
      ]),
      _: 1
    }, 8, ["visible", "title"])
  ], 64))
}